<template>
  <div class="memberBenefits">
    <section-header heading="2" ja="有料会員サービスについて" />
    <div class="download">
      <img class="buyMembershipImage" :src="buyMembershipImagePath" alt="有料会員になると撮影・選択したデータを全部ダウンロードできる！">
    </div>

    <section-header heading="2" ja="有料会員になる" />
    <div class="description">
      有料会員になるには月額330円(税込)の決済購入が必要です<br>
      有料会員の期間や自動更新、解約の期限についてはヘルプ「<span @click="onAboutWeb">有料会員について</span>」をご確認ください<br>
      <span @click="onPrivacyPolicy">プライバシーポリシー</span>と<span @click="onTermsOfUse">利用規約</span>に同意の上、購入をお願いします
    </div>
    <div class="infoLink">
      <div @click="onSCTransactions" class="link-text">特定商取引法に基づく表示</div>
    </div>
    <div v-if="membershipGrade == 1">
      <p-select
          :items="paymentMethodList"
          v-model="paymentMethod" />
      <normal-btn
        :disabled="paymentMethod ==='決済方法を選択' || disableMembership2"
        @click="onMemberRegistration('form1')">有料会員になる</normal-btn>
      <form enctype="application/json" method="post" :action="url1" ref="form1">
        <input type="hidden" name="accessToken" :value="accessToken"/>
        <input type="hidden" name="reserveId" :value="reserveId"/>
        <input type="hidden" name="payType" :value="payType"/>
      </form>
    </div>
    <div class="description">
      <template v-if="disableMembership2">
        現在キャンペーン期間中の為、有料会員登録を行えません<br>
        <br>
      </template>
      <template v-if="membershipGrade >= 2">
        あなたは既に有料会員です<br>
        解約する場合は<span @click="onPaidMemberRemoval">こちら</span>からお願いします<br>
      </template>
      <template v-if="disableMembership">
        現在有料会員登録はできません<br>開始までしばらくお待ちください<br>
      </template>
      <template v-if="membershipGrade == 1">
        ※有料会員登録したのに、反映されていない場合は<br>
        <span @click="onPaidMemberRegistrationConsistency">こちら</span>で会員情報の更新をお願いします<br>
      </template>
    </div>
  </div>
</template>

<script>
  import SectionHeader from '../components/SectionHeader'
  import NormalBtn from '../components/NormalBtn'
  import PSelect from '../components/PSelect'
  import Protobuf from "../mixins/protobuf"

  const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web

  export default {
    name: "MemberBenefits",
    components: {
      SectionHeader,
      NormalBtn,
      PSelect,
    },
    mixins: [ Protobuf ],
    data() {
      return {
        paymentMethod: "決済方法を選択",
        paymentMethodList:[
          "決済方法を選択",
          "d払い",
          "auかんたん決済(au / UQ mobile)/au PAY",
          "ソフトバンク・ワイモバイルまとめて支払い",
          "クレジットカード" ],
        url1: '',
        url2: '',
        accessToken: '',
        reserveId: '',
        payType: '',
        membershipGrade: null,
        disableMembership: false,
        disableMembership2: false,
        disabledMessage: null,
        buyMembershipImagePath: ''
      }
    },
    methods: {
      onMemberRegistration(form) {
        let type = null;
        switch(this.paymentMethod) {
          case 'クレジットカード': type = 0; break;
          case 'd払い': type = 1; break;
          case 'auかんたん決済(au / UQ mobile)/au PAY': type = 2; break;
          case 'ソフトバンク・ワイモバイルまとめて支払い': type = 3; break;
        }
        this.setCariorForm(type, () => this.$nextTick(() => this.$refs[form].submit()))
      },

      setCariorForm(type, callback) {
        const cmdNo = pb.BuyMembershipStartReq.CommandNo.COMMAND_NO
        const message = pb.BuyMembershipStartReq.create({
          membershipGrade: 2,
          payType: type
        })
        const encoded = pb.BuyMembershipStartReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            if (decoded.status === 0) {
              this.url1 = decoded.url
              const json = JSON.parse(decoded.postJson)
              this.accessToken = json.accessToken
              this.reserveId = json.reserveId
              this.payType = json.payType
              this.disableMembership = decoded.disableMembership;
              callback()
            } else if (decoded.status === pb.BuyMembershipStartResp.Status.ALREADY_PURCHASED) {
              this.$router.push('/paidMemberRegistrationUpdate')
            } else {
              this.$_error('Error', { title: 'お支払い方法の選択', statusCode: 100 })
            }
          })
          .catch(() => {
            this.$_error('Error', { title: 'お支払い方法の選択', statusCode: 100 })
          })
      },
      onAboutWeb() {
        this.$router.push("/AboutWeb10")
      },
      onPrivacyPolicy() {
        window.open('https://www.sega.co.jp/privacypolicy/')
      },
      onTermsOfUse() {
        this.$router.push("/terms")
      },
      onSCTransactions() {
        this.$router.push("/SCTransactions")
      },
      onPaidMemberRemoval() {
        this.$router.push("/paidMemberRemoval2")
      },
      onPaidMemberRegistrationConsistency() {
        this.$router.push("/paidMemberRegistrationConsistency")
      },
      async setPlayerInfo() {
        const cmdNo = pb.PlayerInfoReq.CommandNo.COMMAND_NO
        const message = pb.PlayerInfoReq.create()
        const encoded = pb.PlayerInfoReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            this.membershipGrade = decoded.membershipGrade
          })
          .catch(() => {
            this.$_error('Error', { title: 'プロフィール', statusCode: 100 })
          })
      },
      async setMembership() {
        const cmdNo = pb.BuyMembershipListReq.CommandNo.COMMAND_NO
        const message = pb.BuyMembershipListReq.create()
        const encoded = pb.BuyMembershipListReq.encode(message).finish()
        this.post(cmdNo, encoded)
          .then(decoded => {
            this.disableMembership2 = decoded.disableMembership;
            this.disabledMessage = decoded.disableMessage;
            this.buyMembershipImagePath = process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + decoded.imgPath;
          })
      }
    },
    mounted() {
      this.setPlayerInfo()
      this.setMembership()
      sessionStorage.setItem('prevPage', '/MemberBenefits');
    }
  }
</script>

<style lang="scss" scoped>
  .description {
    font-size: 12px;
    color: #373737;
    margin: 30px 30px 0;
    span {
      color: #F63C5B;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  .download {
    margin: 20px 30px 0;
    .buyMembershipImage {
      width: 100%;
      height: auto;
    }
  }
  .infoLink {
    margin-top: 20px;
    padding: 0 30px;
    cursor: pointer;
    & > div {
    margin-top: 15px;
    padding-right: 30px;
    text-align: right;
    font-size: 10px;
    color: #F63C5B;
    background-image:
      linear-gradient(to left, #F63C5B, #F63C5B),
      linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
    background-repeat: no-repeat;
    background-size: 24px 1px, 8px 8px;
    background-position: right 70%, right 40%;
  }
}
</style>
